export type StaffFunctionValue = {
	readonly value: string;
	readonly label: string;
};

/** The server sends a relation by id only (`forceObject: true`): an object, never a bare number. */
export type StaffMemberFacilityPayload = {
	readonly id: number;
};

export type StaffMemberPayload = {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
	readonly jobFunction: StaffFunctionValue;
	readonly phoneNumber: string | null;
	readonly email: string | null;
	readonly facilities: readonly StaffMemberFacilityPayload[];
	readonly linkedBeneficiaryCount: number;
};

export type StaffMembersFetchedPayload = StaffMemberPayload[];

export type StaffMembersFetchedAction = {
	type: 'STAFF_MEMBERS_FETCHED';
	payload: StaffMembersFetchedPayload;
	organizationId: number;
};

export default (payload: StaffMembersFetchedPayload, organizationId: number): StaffMembersFetchedAction => ({
	type: 'STAFF_MEMBERS_FETCHED',
	payload,
	organizationId,
});
